import { useContext } from "react";
import { ModalAlertContext } from "../../contexts/ModalAlertContext";
import { observer } from "mobx-react";
import "./index.css";
import { whiteCheckIcon } from "../../assets";
import { DomPurifyHtml } from "../DomPurifyHtml";

const TextModalAlert = () => {
  const { textModalAlert, closeTextModalAlert } = useContext(ModalAlertContext);


  if (!textModalAlert) return null;

  return (
    <div className="text-modal-alert">
      <div className="text-modal-alert-content">
        <div className="text-modal-alert-content-texts">
          {textModalAlert.title && <h2>{textModalAlert.title}</h2>}
          {textModalAlert.message && <p>{textModalAlert.message}</p>}
          {textModalAlert.html && <DomPurifyHtml html={textModalAlert.html} />}
        </div>
        <button onClick={textModalAlert.onOk} className="button-cta-secondary">
          <img src={whiteCheckIcon} alt="check" />
          <span>{textModalAlert.okText}</span>
        </button>
        {textModalAlert.cancelText && (
          <button onClick={textModalAlert.onCancel} style={{ width: '100%' }} className="button-cta">
            <span>{textModalAlert.cancelText}</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default observer(TextModalAlert);